import { createReducer } from 'reduxsauce';
import { Types } from './actions';

const INITIAL_STATE = {
  // set false to show tutorial by default
  viewedTutorial: false,
  showTutorial: false
};

const setTutorial = (state: any, action: any) => ({
  ...state,
  showTutorial: action.show,
  viewedTutorial: true
});

const clearTutorial = () => INITIAL_STATE;

export default createReducer(INITIAL_STATE, {
  [Types.SET_TUTORIAL]: setTutorial,
  [Types.CLEAR_TUTORIAL]: clearTutorial
});
